'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'croissant';
var width = 512;
var height = 512;
var aliases = [129360];
var unicode = 'f7f6';
var svgPathData = 'M256 48c48.8 0 93.7 16.8 129.1 44.9l-83.9 83.9-46-128.8 .8 0zm163.1 78.9c11.8 14.9 21.6 31.4 29 49.1l-78.1 0 49.1-49.1zM321.9 224l189.9 0-7.4-29.8C476.8 82.7 376.1 0 256 0 114.6 0 0 114.6 0 256 0 376.1 82.7 476.8 194.2 504.5l29.8 7.4 0-189.9 3.9-3.9c13.1 5.6 24.3 10.4 33.6 14.4 1.6-1.6 21.4-21.4 59.5-59.5l10.7-10.7c-3-8.4-7.2-20.2-12.6-35.4l2.9-2.9zM180.4 297.7L92.9 385.1c-28.1-35.5-44.9-80.4-44.9-129.1 0-5 .2-9.9 .5-14.8l131.8 56.5zM126.9 419.1l49.1-49.1 0 78.1c-17.8-7.4-34.3-17.2-49.1-29zM57.7 192.9C79.5 124.4 135.9 71.2 206.4 54l69.9 195.8-25.8 25.8-192.8-82.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCroissant = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;